module.exports = __webpack_public_path__ + "img/book_list_detail_header.e7b6993d.png";